"use client";

import { useContext, useEffect, useState } from "react";

import { Button } from "@/components/Button";
import { GridSelectorLandingProps } from "./types";
import { QREditorContextProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { useWindowSize } from "@/hooks/browser/useWindowsSize";
import "./styles.scss";

export const GridSelectorLanding = (props: GridSelectorLandingProps) => {
  const { data, onClickQRselect, onHoverChangeQRType } = props;
  const screenSize = useWindowSize();

  const [isGridContracted, setIsGridContracted] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(data.items);

  const qrEditorContext = useContext<QREditorContextProps<any>>(QREditorContext);

  const handleViewMoreButton = (event) => {
    setIsGridContracted((prev) => !prev);
    event.target.blur();
  };

  useEffect(() => {
    if (isGridContracted) {
      setItemsToShow([...itemsToShow].slice(0, 5));
    } else {
      setItemsToShow(data.items);
    }
  }, [isGridContracted]);

  useEffect(() => {
    if (screenSize.isMobile) {
      setIsGridContracted(true);
      setItemsToShow([...itemsToShow].slice(0, 5));
    }
  }, []);

  return (
    <>
      <div className="qr-selector-grid">
        {/*  //TODO: QR-5021 N/A implementacion buttonLib. Se creara nuevo componente específico */}
        <Button
          bold
          dataQA={data.mainItem.data_qa}
          icon={
            <div className="button__icon">
              <div>
                <img
                  src={`/svg/icon-qr-${data.mainItem.id}.svg`}
                  alt={`QR ${data.mainItem.title} icon`}
                  title={`QR ${data.mainItem.title} icon`}
                />
              </div>
            </div>
          }
          description={data.mainItem.subtitle}
          active={data.mainItem.id === qrEditorContext?.qrData.type}
          onMouseEnter={() => onHoverChangeQRType(data.mainItem.id, data.mainItem.title)}
          onClick={() => onClickQRselect(data.mainItem)}
          label={data.mainItem.title}
          className={"qr-landing-button"}
        />
        {/*  //TODO: QR-5021 N/A implementacion buttonLib. Se creara nuevo componente específico */}
        {itemsToShow?.map((item, i) => (
          <Button
            key={i}
            bold
            dataQA={item.data_qa}
            icon={
              <div className="button__icon">
                <div>
                  <img
                    src={`/svg/icon-qr-${item.id}.svg`}
                    alt={`QR ${item.title} icon`}
                    title={`QR ${item.title} icon`}
                  />
                </div>
              </div>
            }
            active={item.id === qrEditorContext?.qrData.type}
            onMouseEnter={() => onHoverChangeQRType(item.id, item.title)}
            onClick={() => onClickQRselect(item)}
            label={item.title}
            className={"qr-landing-button"}
          />
        ))}
        {/*  //TODO: QR-5021 N/A implementacion buttonLib. Se creara nuevo componente específico */}
        <Button
          dataQA={data.mainItem.data_qa}
          onClick={(event) => handleViewMoreButton(event)}
          onMouseEnter={() => onHoverChangeQRType(null, null)}
          label={isGridContracted ? "View More" : "View Less"}
          className={`qr-landing-button show-more-button ${isGridContracted ? "" : "show-more-button--active"}`}
        />
      </div>
    </>
  );
};
